<template>
  <span class="hotel-map-tooltip-content">
    <span>{{ hotel.description }}</span>
    <span
      v-if="preferredPartnerAsset || hotel.best_price || hotel.low_priority"
      class="hotel-map-tooltip-content__badges"
    >
      <img
        v-if="preferredPartnerAsset"
        :src="preferredPartnerAsset"
        :alt="`${preferredPartnerLabel} preferred partner`"
        class="hotel-map-tooltip-content__partner"
      >
      <img
        v-if="hotel.best_price"
        :src="bestPriceAsset"
        alt="Best price"
        class="hotel-map-tooltip-content__best-price"
      >
      <img
        v-if="hotel.low_priority"
        :src="lowPriorityAsset"
        alt="Low priority"
        class="hotel-map-tooltip-content__low-priority"
      >
    </span>
  </span>
</template>

<script>
const PREFERRED_PARTNER_ASSETS = Object.freeze({
  bronze: require('@/assets/img/preferred-bronze.svg'),
  silver: require('@/assets/img/preferred-silver.svg'),
  gold: require('@/assets/img/preferred-golden.svg')
})

export default {
  name: 'HotelMapTooltipContent',
  props: {
    hotel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      bestPriceAsset: require('@/assets/img/best-price.svg'),
      lowPriorityAsset: require('@/assets/img/hotel-low-priority.svg')
    }
  },
  computed: {
    preferredPartnerAsset() {
      return PREFERRED_PARTNER_ASSETS[this.hotel.preferred_partner] || null
    },
    preferredPartnerLabel() {
      const partner = this.hotel.preferred_partner
      if (!partner) return ''
      return partner.charAt(0).toUpperCase() + partner.slice(1)
    }
  }
}
</script>

<style lang="sass" scoped>
.hotel-map-tooltip-content
  display: inline-flex
  flex-direction: column
  align-items: flex-start
  gap: 3px
  white-space: nowrap

.hotel-map-tooltip-content__badges
  display: flex
  align-items: center
  gap: 6px

.hotel-map-tooltip-content__partner
  width: 17px
  height: 20px
  flex-shrink: 0

.hotel-map-tooltip-content__best-price
  width: 57px
  height: 14px
  flex-shrink: 0

.hotel-map-tooltip-content__low-priority
  width: 68px
  height: 14px
  flex-shrink: 0
</style>
